import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

/* dynamic pages */

const Home = () => import('./pages/Home.vue' /* webpackChunkName: 'home' */);
const publicHome = () => import('./pages/PublicHome.vue' /* webpackChunkName: 'publicHome' */);
const MantenedorBases = () => import('./pages/mantenedor/bases/Index' /* webpackChunkName: 'bases' */);
const MantenedorProcesos = () => import('./pages/mantenedor/procesos/Index' /* webpackChunkName: 'procesos' */);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/portal-base-datos',
    name: 'publicHome',
    component: publicHome,
  },
  {
    path: '/bases',
    name: 'bases',
    component: MantenedorBases
  },
  {
    path: '/procesos',
    name: 'procesos',
    component: MantenedorProcesos
  },
];

const router = new VueRouter({
  mode: 'history',
  routes
});

router.beforeEach((to, from, next) => {
    next();
  // }
});

export default router;

